<template>
<div class="chapter">
<div class="inner_page">
<p class="small"><span class="com-rorohiko-pagestaker-style"><a id="_idTextAnchor000"></a><a id="_idTextAnchor001"></a><a id="_idTextAnchor002"></a><a id="_idTextAnchor003"></a><a id="_idTextAnchor004"></a><a id="_idTextAnchor005"></a></span><span epub:type="pagebreak" id="pagei" title="i"></span></p>
<p class="firstleft"><span epub:type="pagebreak" id="pageii" title="ii"></span></p>
<p><span epub:type="pagebreak" id="pageiii" title="iii"></span></p>
<p class="tp1">EXPLORATIONS IN <br/>ASIAN CHRISTIANITY</p>
<p class="tp2">History, Theology, <br/>and Mission</p>
<p class="tp3">SCOTT W. SUNQUIST</p>
<p class="first"><br/></p>
<p class="firstcenter"><a href="http://www.IVPacademic.com/" target="_blank"><img alt="IVP Academic Imprint" src="Images/IVPAcademic.png"/></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02titlepage.vue?3ac94d3e